// extracted by mini-css-extract-plugin
module.exports = {"layout":"PlusIcon_layout__td9W2"};